<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <el-container style="height: 650px">
            <el-header style="line-height: 60px">
                <el-row type="flex" :gutter="20" align="middle">
                    <el-col :span="24">
                        <el-button size="small" class="btn-primary" v-if="permission.add" @click="routeToAttendanceTimeSetDetail">{{ permission.add }}</el-button>
                        <el-button size="small" class="btn-primary" v-if="permission.del" @click="delAttendanceTimeSet">{{ permission.del }}</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-container style="height: 100%">
                <el-main width="100%" height="100%" style="padding-top: 0px">
                    <el-table
                        @selection-change="handleSelectionChange"
                        :header-cell-style="{ background: '#F2F6FC' }"
                        :data="attendanceTimeSetsList"
                        border
                        style="width: 100%"
                        :sort="{ prop: 'CreateTime' }"
                    >
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column min-width="250px" prop="SetName" label="工作班次"></el-table-column>
                        <el-table-column min-width="200px" prop="SetTypeName" label="类型"></el-table-column>
                        <el-table-column min-width="200px" prop="Period" label="周期"></el-table-column>
                        <el-table-column min-width="200px" prop="IsDefault" label="默认"></el-table-column>
                        <el-table-column min-width="200px" prop="IsAISet" label="智能排班"></el-table-column>
                        <el-table-column min-width="250px" prop="CreateTime" label="添加时间"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <div class="ops-ctn">
                                    <el-button type="text" size="mini" v-if="permission.edit" @click="routeToAttendanceTimeSetDetail(scope)">{{ permission.edit }}</el-button>
                                    <el-button type="text" size="mini" v-if="permission.del" @click="delAttendanceTimeSet(scope)">{{ permission.del }}</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-main>
                <div class="pagination-ctn">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchData.page"
                        :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                        :page-size="searchData.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="attendanceTimeSetsList.length"
                    ></el-pagination>
                </div>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            permission: this.$util.getPermission('WorkTimeSetManage'),
            searchData: {
                entpId: this.$util.getLocalStorage('userMsg').EntpId,
                name: '',
                page: 1,
                limit: 15
            },
            attendanceTimeSetsList: [
                // {
                //   Id: "f70ef255-1717-4a33-a4a1-afe7e692380d",
                //   EntpId: "39e3b7ac-9744-4be4-9dfc-adbb5c77308f",
                //   SetName: "全天",
                //   IsAISet: false,
                //   Period: 1,
                //   IsDefault: false,
                //   CreateTime: "2020-04-17 18:14",
                //   SetTypeName: "按周"
                // }
            ],
            attendanceTimeSetIds: ''
        };
    },
    watch: {
        attendanceTimeSetsList(val) {
            val.forEach(element => {
                element.IsAISet = element.IsAISet == true ? '是' : '否';
                element.IsDefault = element.IsDefault == true ? '是' : '否';
            });
        }
    },
    created() {
        this.getAttendanceTimeSetsList();
    },
    mounted() {},
    methods: {
        routeToAttendanceTimeSetDetail(scope) {
            let id = '';
            if (scope.row) {
                id = scope.row.Id;
            }
            this.$router.push({
                path: '/attendanceSetting/workTimeSetManageEdit',
                query: { Id: id }
            });
        },
        //获取工作班次列表
        getAttendanceTimeSetsList() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetAttendanceTimeSetsList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.attendanceTimeSetsList = res.data;
                    }
                })
                .catch(err => {});
        },

        //删除工作班次
        delAttendanceTimeSet(scope) {
            let id = '';
            if (scope.row != undefined) {
                id = scope.row.Id;
            } else {
                id = this.attendanceTimeSetIds;
            }

            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/DelAttendanceTimeSet?ids=' + id
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.getAttendanceTimeSetsList();
                        this.dialogVisible = false;
                        this.$util.successMsg('删除成功');
                    }
                })
                .catch(err => {});
        },
        handleSelectionChange(val) {
            this.attendanceTimeSetIds = '';
            val.forEach(element => {
                this.attendanceTimeSetIds += element.Id + ',';
            });
            this.attendanceTimeSetIds = this.attendanceTimeSetIds.slice(0, this.attendanceTimeSetIds.length - 1);
        },
        // 分页处理
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getAttendanceTimeSetsList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getAttendanceTimeSetsList();
        }
    }
};
</script>
<style lang="less" scoped></style>
